import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestForm = (
  datasetId: string,
  token: string | null,
  forceHeader?: string
  //TODO: Create return type
): Promise<any> =>
  fetcher<any>(
    `${apiEndpoints.routes.forms}/${datasetId}`,
    'GET',
    token,
    forceHeader
  );
